function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "id2"
}, /*#__PURE__*/React.createElement("path", {
  d: "m288 428.82h254.67v262.22h-254.67z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m229.45 3.6406h-204.63c-11.758 0-21.285 9.5234-21.285 21.273v162.79c0 11.75 9.5273 21.273 21.285 21.273h73.656l28.652 49.602 28.652-49.602h73.664c11.754 0 21.281-9.5234 21.281-21.273v-162.79c0-11.75-9.5273-21.273-21.281-21.273",
  fill: "#e1e0d9"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-288.19 -428.82)",
  clipPath: "url(#id2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m313.01 436.1c-9.7266 0-17.641 7.9102-17.641 17.633v162.79c0 9.7227 7.9141 17.629 17.641 17.629h73.656c1.3008 0 2.5039 0.69531 3.1562 1.8242l25.496 44.137 25.5-44.137c0.65234-1.1289 1.8516-1.8242 3.1523-1.8242h73.664c9.7227 0 17.637-7.9062 17.637-17.629v-162.79c0-9.7226-7.9141-17.633-17.637-17.633zm102.31 254.94c-1.3008 0-2.5039-0.69141-3.1562-1.8203l-27.598-47.781h-71.555c-13.746 0-24.93-11.176-24.93-24.914v-162.79c0-13.738 11.184-24.918 24.93-24.918h204.62c13.746 0 24.926 11.18 24.926 24.918v162.79c0 13.738-11.18 24.914-24.926 24.914h-71.555l-27.605 47.781c-0.64844 1.1289-1.8516 1.8203-3.1562 1.8203",
  fill: "#231f20"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m191.56 69.508-13.09-13.078-70.215 70.176-32.469-32.453-13.09 13.082 45.559 45.535 83.305-83.262",
  fill: "#00a499"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m67.857 107.23 40.402 40.383 78.148-78.109-7.9336-7.9297-67.637 67.602c-1.4258 1.4258-3.7305 1.4258-5.1562 0l-29.891-29.875zm40.402 49.176c-0.93359 0-1.8672-0.35547-2.5781-1.0664l-45.559-45.535c-1.4219-1.4219-1.4219-3.7266 0-5.1524l13.09-13.078c0.68359-0.6836 1.6094-1.0664 2.5781-1.0664 0.96485 0 1.8906 0.38281 2.5742 1.0664l29.895 29.875 67.641-67.602c1.4219-1.4219 3.7305-1.4219 5.1523 0l13.09 13.082c0.6836 0.68359 1.0664 1.6094 1.0664 2.5742 0 0.96875-0.38281 1.8945-1.0664 2.5781l-83.305 83.258c-0.71094 0.71094-1.6445 1.0664-2.5781 1.0664",
  fill: "#231f20"
});

function SvgIntroFormIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339.05,
    height: 349.37,
    viewBox: "0 0 254.42 262.22",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFormIcon5);
export default __webpack_public_path__ + "static/media/introFormIcon5.e3a5108c.svg";
export { ForwardRef as ReactComponent };